import { render, staticRenderFns } from "./135.vue?vue&type=template&id=4b86204e&scoped=true&"
var script = {}
import style0 from "./135.vue?vue&type=style&index=0&id=4b86204e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b86204e",
  null
  
)

export default component.exports